module.exports = __webpack_public_path__ + "media/audio25.223d5666.wav";